/**
 * @file 各种域名解析
 */

import { isClient } from '@vueuse/shared';

const appEnv = import.meta.env.VITE_APP_ENV;

// 各环境主域名(主要用于ssr，构建阶段这些固定域名被墙也可以正常访问)
const mainDomain: Record<string, string> = {
  production: 'toobit.com',
  test: 'wcsbapp.com',
  development: 'wcsbapp.com'
};

// 公共后缀处理函数
const getSuffixAdjustedDomain = (domain: string) => {
  const publicSuffixes = ['co.uk', 'com.au', 'gov.vn', 'or.kr', 'net.nz'];
  for (const suffix of publicSuffixes) {
    if (domain.endsWith(suffix)) {
      return domain.split('.').slice(-3).join('.');
    }
  }
  return domain;
};

export const getClientMainDomain = (url = window.location.href) => {
  try {
    const domain = new URL(url).hostname;
    if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(domain) || domain === 'localhost') {
      return domain;
    }
    const adjustedDomain = getSuffixAdjustedDomain(domain);
    return adjustedDomain.split('.').slice(-2).join('.');
  } catch (e) {
    return url;
  }
};

/**
 * 处理子域名的规则
 *
 * @param env
 * @returns
 */
const getEnvPrefix = (env: string) => {
  let apiPrefix = '';
  let hostPrefix = '';

  switch (env) {
  case 'development':
    // 本地开发
    apiPrefix = appEnv || 'test1';
    hostPrefix = appEnv || 'test1';
    break;
  case 'test':
    // 测试环境域名例如 www.test1.wscsbapp.com,或 www.test1-1.wscsbapp.com，老板定的规则
    // apiPrefix = appEnv.match(/test\d+/)?.[0] || 'test1';
    apiPrefix = appEnv;
    hostPrefix = appEnv;
    break;
  default:
    break;
  }

  return {
    web: `${hostPrefix}`,
    h5: `${hostPrefix}`,
    api: apiPrefix,
    ws: apiPrefix
  };
};

const getBaseDomain = (env: string) => {
  return isClient
    ? getClientMainDomain()
    : mainDomain[env.includes('test') ? 'test' : env];
};

export const getEnvironmentHost = (env: string) => {
  const baseDomain = getBaseDomain(env);
  const subDomainPrefix = getEnvPrefix(env);

  const getPrefixPath = (prefix: string) => {
    return prefix ? `.${prefix}.` : '.';
  };
  return {
    api: `https://bapi${getPrefixPath(subDomainPrefix.api)}${baseDomain}`,
    ws: `wss://bws${getPrefixPath(subDomainPrefix.ws)}${baseDomain}`,
    wsIm: `wss://api-plaza${getPrefixPath(subDomainPrefix.ws)}${baseDomain}`,
    web: `https://www${getPrefixPath(subDomainPrefix.web)}${baseDomain}`,
    h5: `https://h5${getPrefixPath(subDomainPrefix.h5)}${baseDomain}`,
    plazaApi: `https://api-plaza${getPrefixPath(subDomainPrefix.api)}${baseDomain}`,
    locale: env === 'dev-production' ? 'https://www.test1.wcsbapp.com' : `https://www${getPrefixPath(subDomainPrefix.web)}${baseDomain}`
  };
};
